import React, {useEffect, useState} from "react";
import {apiList} from "../../../../services/Admin/user";
import moment from "moment";
import {Button, Checkbox, FormControl, Grid, MenuItem, Paper, Select} from "@mui/material";
import MsgSuccess from "../../../../components/MsgSuccess";
import MsgError from "../../../../components/MsgError";
import HeaderPage from "../../../../components/Admin/HeaderPage";
import Table from "../../../../components/Table";
import {RouteAdmin} from "../../../../routes/RouteAdmin";
import {DASH_MAX_ROW} from "../../../../utils/constants";
import InputText from "../../../../components/Inputs/InputText";
import InputSelect from "../../../../components/Inputs/InputSelect";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";

export default function Management() {
    const [rows, setRows] = useState([])
    const [msgError, setMsgError] = useState([])
    const [msgSuccess, setMsgSuccess] = useState([])
    const [loading, setLoading] = useState(true)
    const [rowCount, setRowCount] = useState(0)
    const [state, setState] = useState(initialValues)

    const params = new URLSearchParams(window.location.search)


    useEffect(() => {
        setLoading(true)
        const timeOutId = setTimeout(() => {
            getItemsData()
        }, 500)
        return () => clearTimeout(timeOutId)
    }, [state])

    useEffect(() => {
        if (params.get("msg-error")) {
            setMsgError([params.get("msg-error")])
        } else if (params.get("msg")) {
            setMsgSuccess([params.get("msg")])
        }
    }, [])

    const getItemsData = () => {
        setMsgError([])

        // Renombramos en caso de lo que columna no coinicda con el nombre de la base de datos
        let field = state.sort.field
        if (state.sort.field === "roleName") { field = "role" }
        if (state.sort.field === "active") { field = "isActive" }
        if (state.sort.field === "access") { field = "lastActivity" }

        let params = {
            limit: DASH_MAX_ROW,
            offset: state.offset ?? 0,
            field: field,
            sort: state.sort.sort
        }

        if (state.email) { params.email = state.email }
        if (state.role) { params.role = state.role }

        apiList(params).then(resp => {
            setRowCount(resp.data?.count)

            let temp = resp.data.data?.map(doc => {
                return {
                    roleName: doc?.role?.niceName,
                    access: doc.isActive ? "Si" : "No",
                    active: moment.unix(doc.lastActivity).format("D/M/Y"),
                    ...doc,
                }
            })

            setRows(temp)
            setLoading(false)
        }).catch(err => {
            setMsgError(err.response?.data?.msg)
            setLoading(false)
            setRows([])
        })
    }

    return (
        <>
            <HeaderPage title="Users">
                <Button
                    variant="contained"
                    color="primary"
                    style={{float: "right", margin: "20px 0px"}}
                    href="/admin/users/create"
                >
                    + Añadir
                </Button>
            </HeaderPage>

            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <MsgError msg={msgError}/>
                    <MsgSuccess msg={msgSuccess}/>
                </Grid>

                <Grid item xs={12}>

                    <Paper sx={{p: 2, display: 'flex', flexDirection: 'column'}}>

                        <Filters
                            state={state}
                            setState={setState}
                        />

                        <Table
                            columns={tableColumns()}
                            rows={rows}
                            rowCount={rowCount}
                            filter={state}
                            setFilter={setState}
                            loading={loading}
                            checkbox={true}
                        />
                    </Paper>
                </Grid>
            </Grid>
        </>
    );
}

function initialValues(props) {
    return {
        offset: 0,
        sort: { field: "id", sort: "desc" },
        email: "",
        role: "ROLE_ADMIN"
    }
}

function tableColumns() {
    return [
        {
            field: "id",
            headerName: "ID",
            flex: 1
        },
        {
            field: "active",
            headerName: "ACTIVO",
            flex: 1
        },
        {
            field: "role",
            headerName: "TIPO DE USUARIO (ROL)",
            width: 200,
            flex: 1
        },
        {
            field: "name",
            headerName: "NOMBRE",
            flex: 1,
            editable: true
        },
        {
            field: "email",
            headerName: "EMAIL",
            flex: 2
        },
        {
            field: "access",
            headerName: "ACCESO A LA PLATAFORMA",
            flex: 2
        },
        {
            field: "actions",
            headerName: "ACCIONES",
            renderCell: (params) => {
                return (
                    <Link to={`${RouteAdmin.USER_EDIT.path}/${params.row.id}`}>Edit</Link>
                )
            },
        },
    ]
}

function Filters(props) {

    const {state, setState} = props
    const {t} = useTranslation()

    const optionsRole = [{id: "ROLE_ADMIN", name: t('user.roles.admin')}]

    const handleChange = (event) => {
        state[event.target.name] = event.target.value
        state["offset"] = 0
        setState({...state})
    }

    return (
        <Grid container spacing={1} style={{marginBottom: '20px'}}>
            <Grid item xs={6}>
                <InputText
                    label="Email"
                    name="email"
                    value={state.email}
                    onChange={handleChange}
                />
            </Grid>

            <Grid item xs={6}>
                <InputSelect
                    label={t('user.role')}
                    name="role"
                    required
                    disabled
                    onChange={handleChange}
                    value={"ROLE_ADMIN"}
                    options={optionsRole}
                />
            </Grid>
        </Grid>
    )
}
